import React, { useEffect, useState } from "react";
import { server } from "../../common";
import { useParams } from "react-router-dom";

const EventRegistration = () => {
  const { id } = useParams();
  const [event, setEvent] = useState([]);

  useEffect(() => {
    getdata();
  }, []);

  // industry
  const getdata = () => {
    server
      .get(`/event/indeventregistration/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setEvent(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return <div>EventRegistration</div>;
};

export default EventRegistration;
